import React from 'react';
import DashboardLayout from './DashboardLayout';
import MetricCard from './MetricCard';
import ComplaintsTable from './ComplaintsTable';
import { useGetComplaintsDashboardCountQuery } from '../../redux/complaintApi';
import { useAuth } from '../../context/AuthContext';
import {
  complaintsListLink,
  statusFromDashboardCountKey,
} from '../../utils/complaintListFilters';

const pickCount = (payload, keys = [], fallback = 0) => {
  for (const k of keys) {
    const v = payload?.[k];
    if (v == null || v === '') continue;
    const n = Number(v);
    if (!Number.isNaN(n)) return n;
  }
  return fallback;
};

function EmployeeDashboard() {
  const { can, area } = useAuth();
  const { data: dashboardCountRes, isLoading } = useGetComplaintsDashboardCountQuery();
  const counts = dashboardCountRes?.data ?? dashboardCountRes ?? {};

  const metric = (title, countKeys) => {
    const status = statusFromDashboardCountKey(countKeys[0]);
    return {
      title,
      value: isLoading ? '—' : String(pickCount(counts, countKeys)),
      to: complaintsListLink(area, status),
    };
  };

  const metrics = can('complaints')
    ? [
        metric('Total Complaints', ['total_complaints']),
        metric('In-Progress Complaints', ['inprogress_complaints']),
        metric('Resolved Complaints', ['resolved_complaints']),
        metric('Overdue Complaints', ['overdue_complaints']),
      ]
    : [];

  return (
    <DashboardLayout title="Dashboard">
      <div className="space-y-6 py-4">
        {metrics.length > 0 ? (
          <div className="grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-4">
            {metrics.map((m, i) => (
              <MetricCard key={i} title={m.title} value={m.value} to={m.to} />
            ))}
          </div>
        ) : (
          <div className="rounded-xl bg-white p-6 text-sm text-gray-600 shadow-sm">
            You don’t have permission to view complaints.
          </div>
        )}

        {can('complaints') ? (
          <div className="mt-2">
            <ComplaintsTable
              showRaisedBy={true}
              showViewAll={true}
              viewAllPath="/dashboard/employee/complaints"
            />
          </div>
        ) : null}
      </div>
    </DashboardLayout>
  );
}

export default EmployeeDashboard;
